

























































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { institutionServer, menuServe, professionServer, roleServe, spaceServe, userServe, userManagementServe, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class AddUser extends Vue {
  @Prop(Object) row!: any; // 从父组件接受过来一行的数据
  @Prop(Boolean) setRoleFlag!: boolean; // 分配角色是否显示
  // dialog 中的树数据
  organTreeData: any = [];
  treeData: any = [];
  // 分配角色表格数据
  roleTableDate: any[] = [];
  // 岗位列表
  stationLists: any[] = [];

  areaTreeData: any = [];

  // 用户数据
  private newObj: any = {
    email: '',
    mobile: '',
    password: '',
    username: '',
  };
  // 表单数据
  formData: any = {
    id: '',
    deptId: '', // 归属机构
    spaceId: '', // 归属公司
    areaId: '', // 归属区域
    name: '', // 登录账号/员工姓名
    jobNum: '', // 员工工号
    postIdList: [], // 岗位id列表
    postList: [], // 角色id列表
    registerUser: {
      email: '',
      mobile: '',
      password: '',
      username: '',
    }, // 注册用户
    deptPrincipal: '', // 科室负责人
    education: '', // 学历
    hireDate: '', // 雇佣日期
    fireDate: '', // 解雇日期
    address: '', // 详细地址
    sex: '', // 性别
    workStatus: '', // 工作状态
  };
  roleIdList: any = []; // 角色id列表
  // 科室负责人
  deptPrincipalList: Array<any> = [
    {
      index: '0',
      value: true,
      label: '是',
    },
    {
      index: '1',
      value: false,
      label: '否',
    },
  ];
  // 学历
  educationList: Array<any> = [
    {
      index: '0',
      value: '小学',
      label: '小学',
    },
    {
      index: '1',
      value: '初中',
      label: '初中',
    },
    {
      index: '2',
      value: '高中',
      label: '高中',
    },
    {
      index: '3',
      value: '大学专科',
      label: '大学专科',
    },
    {
      index: '4',
      value: '全日制本科',
      label: '全日制本科',
    },
    {
      index: '5',
      value: '硕士研究生',
      label: '硕士研究生',
    },
    {
      index: '6',
      value: '博士研究生',
      label: '博士研究生',
    },
  ];
  // 性别
  sexList: Array<any> = [
    {
      index: '0',
      value: '男',
      label: '男',
    },
    {
      index: '1',
      value: '女',
      label: '女',
    },
  ];
  // 工作状态
  workStatusList: Array<any> = [
    {
      value: '在职',
      label: '在职',
    },
    {
      value: '在岗',
      label: '在岗',
    },
    {
      value: '离职',
      label: '离职',
    },
    {
      value: '长假',
      label: '长假',
    },
  ];

  // 表单验证规则
  formRules: object = {
    deptId: [{ required: true, message: '必填信息', trigger: ['change', 'blur'] }], // 机构验证规则
    areaId: [{ required: true, message: '必填信息', trigger: ['change', 'blur'] }], // 机构验证规则
    name: [{ required: true, message: '必填信息', trigger: 'blur' }], // 登录账号验证规则
  };

  // 表单验证规则
  newObjRules: object = {
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { max: 20, message: '长度最大为20个字符', trigger: 'blur' },
      { validator: this.validatePassword, trigger: 'blur' },
    ], // 用户密码验证规则
    username: [
      { required: true, message: '必填信息', trigger: 'blur' },
      { validator: this.validateMobile, trigger: 'blur' },
    ], // 用户名验证规则
    mobile: [
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { max: 11, message: '长度最大为11个字符', trigger: 'blur' },
    ], // 用户手机号验证规则
  };

  scrollbar = true;

  // userInfo: any = {};
  // 开启编辑用户信息的开关
  private editUserSwitch = false;
  // 编辑人员信息的验证规则
  editUserObjRules: object = {};
  // 原始的用户信息
  sourceUserInfo: any = {};
  userInfo: any = {
    email: '',
    mobile: '',
    password: '',
    username: '',
    nickname: '',
  };
  // 修改用户信息（editUser、addUSER）
  private editUserMode = 'editUser';

  /**
   * @todo 后期需要优化的部分
   * @desc vue 创建数据生命周期,获取父组件传递过来那一行员工的数据。
   * @param1 无
   * @returns 无
   */
  async created() {
    if (this.setRoleFlag) {
      this.formData = {
        id: '',
        deptId: '', // 归属机构
        spaceId: '', // 归属公司
        areaId: '', // 归属区域
        name: '', // 登录账号/员工姓名
        jobNum: '', // 员工工号
        postIdList: [], // 岗位id列表
        postList: [], // 角色id列表
        registerUser: {
          email: '',
          mobile: '',
          password: '',
          username: '',
        }, // 注册用户
      };
      this.roleIdList = []; // 角色id列表
      await this.getTableData('1');
    } else {
      this.formData = this.row;
      await this.getTableData('2');
      // setTimeout(() => {
      if (this.row.postIdList) {
        this.row.postList.map((res: any) => {
          this.formData.postIdList.push(res.postId);
        });
      }
      // }, 200);
      if (this.formData.roleList) {
        this.formData.roleList.map((haha: any) => {
          this.roleIdList.push(haha.roleId);
        });
      }
    }
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * 【验证】验证用户密码
   * @Params
   * @return
   **/
  private async validatePassword(rule: any, value: any, callback: any) {
    const passwordReg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[.@#$%^&+=!])(?=\S+$).{8,20}$/;
    if (value && !passwordReg.test(value)) {
      callback(new Error('密码格式：数字,英文, 特殊字符(.@#$%^&+=)至少有一个，长度为8到20位'));
    }
    callback();
  }

  /**
   * 【验证】验证用户手机号
   * @Params
   * @return
   **/
  private async validateMobile(rule: any, value: any, callback: any) {
    const passwordReg = /^(?=.*[0-9a-zA-Z]).{8,20}$/;
    if (!passwordReg.test(value)) {
      callback(new Error('用户名格式：数字,英文, 特殊字符(.@#$%^&+=)至少有一个，长度为8到20位'));
    }
    callback();
  }

  async getTableData(type: any) {
    if (type === '2') {
      // 发起接口请求，获取角色数据
      userManagementServe
        .getUserInfoById(this.formData.userId)
        .then((res: any) => {
          this.userInfo = res.data;
          // 密码是密钥不显示
          this.userInfo.password = '';
          // 拷贝一份原始
          this.sourceUserInfo = { ...this.userInfo };
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    }
    // 获取公司数据
    await spaceServe
      .getAllData({})
      .then((res: any) => {
        if (res.code === '200') {
          this.treeData = res.data;
          this.formData.spaceId = res.data && res.data.length ? res.data[0].id : '';
        }
      })
      .catch(() => {
        this.$message.error('初始化空间数据失败,请稍后重试!');
      });
    let data: any = {};
    if (this.formData.spaceId) {
      data = {
        spaceId: this.formData.spaceId,
      };
    }
    // 发起接口请求，获取角色数据
    roleServe
      .getRoleDataListAll(data)
      .then((res: any) => {
        this.roleTableDate = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });

    // 发起接口请求，获取岗位数据
    professionServer
      .getPageDataAll(data)
      .then((res: any) => {
        this.stationLists = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });

    // 获取机构数据
    await institutionServer
      .getDeptAndSubDeptList({})
      .then((res: any) => {
        if (res.code === '200') {
          this.organTreeData = arrayToTree(res.data);
        } else {
          this.$message.error('获取数据失败,请重试!');
        }
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败,请重试!');
      });
    const userInfo: any = JSON.parse((localStorage as any).getItem('userInfo'));
    await regionServe.getAreaAndSubAreaList({ areaId: userInfo.areaId }).then((res: any) => {
      if (res.code === '200') {
        this.areaTreeData = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  /**
   * @desc 处理分配角色 table 点击事件
   * @param1 row：点击的这一行数据
   * @returns 暂无
   */
  handleRowClick(row: any): void {
    (this.$refs.roleTableRef as any).toggleRowSelection(row);
  }

  /**
   * @desc  每当表格单行选中状态发生变化时触发，将被选中的数组赋值。
   * @param1 表格上被选中的数组
   * @returns 暂无
   */
  handleSelectionChange(val: any) {
    // if (val) {
    //   val.map((re: any) => {
    //     this.roleIdList.push(re.id);
    //   });
    // } else {
    //   this.roleIdList = [];
    // }
    if (val && val.length) {
      this.roleIdList = val.map((item: any) => item.id);
    } else {
      this.roleIdList = [];
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增用户
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formDataOrg: any = 'formDataOrg';
    const fromStr: any = 'formData';
    const newObj: any = 'newObj';
    const formDataOrgComponent: any = this.$refs[formDataOrg];
    const formComponent: any = this.$refs[fromStr];
    const newObjComponent: any = this.$refs[newObj];
    formDataOrgComponent.validate((validOrg: any) => {
      if (!validOrg) {
        return;
      }
    });
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
    });
    if (this.setRoleFlag) {
      // setRoleFlag -true: 新增， false：编辑
      newObjComponent.validate((valid: any) => {
        if (!valid) {
          return;
        }
        switch (this.setRoleFlag) {
          case true:
            this.addFunctionData();
            break;
          case false:
            this.editFunctionData();
            break;
        }
      });
    } else {
      if (this.setRoleFlag) {
        this.addFunctionData();
      }
      if (!this.setRoleFlag) {
        this.editFunctionData();
      }
    }
  }

  /**
   * 【接口】新增功能
   */
  private addFunctionData() {
    this.formData.registerUser = this.newObj;
    userServe
      .addUserData({ ...this.formData, roleIdList: this.roleIdList })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        } else {
          this.$message.warning(res.msg);
        }
        // else if (res.code === '10505') {   101406
        //   this.$message.warning('用户名已存在');
        // }
      })
      .catch((res: any) => {
        // this.$message.error('添加失败,请稍后重试!');
        this.$message.error(res.msg);
      });
  }

  /**
     @description: 数组去重
     @author: cxf
     @update: cxf 2021/9/26 17:25
     **/
  public unique(arr: any) {
    for (let i = 0; i < arr.length; i++) {
      for (let j = i + 1; j < arr.length; j++) {
        if (arr[i] === arr[j] || arr[i] === undefined || arr[j] === undefined) {
          // 第一个等同于第二个，splice方法删除第二个
          arr.splice(j, 1);
          j--;
        }
      }
    }
    return arr;
  }

  /**
   * 【接口】编辑功能
   */
  private editFunctionData() {
    const obj = { ...this.formData, roleIdList: this.roleIdList };
    // 如果处于修改用户信息的情况下，将修改后用户信息
    if (this.editUserSwitch) {
      if (this.editUserMode === 'editUser') {
        obj.editUser = {
          userId: this.userInfo.id,
          email: this.userInfo.email,
          mobile: this.userInfo.mobile,
          password: this.userInfo.password ? this.userInfo.password : null,
          username: this.userInfo.username,
          nickname: this.userInfo.nickname,
        };
      } else if (this.editUserMode === 'addUser') {
        obj.registerUser = this.userInfo;
      }
    }

    userServe
      .editUserData(obj)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }

  /**
   * 编辑用户信息的开关
   */
  editUserInfoClick(switchFlag: boolean) {
    if (switchFlag) {
      this.editUserObjRules = {
        password: [
          { max: 20, message: '长度最大为20个字符', trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' },
        ],
        username: [
          { required: true, message: '必填信息', trigger: 'blur' },
          { validator: this.validateMobile, trigger: 'blur' },
        ], // 用户名验证规则
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { max: 11, message: '长度最大为11个字符', trigger: 'blur' },
        ], // 用户手机号验证规则
      };
    } else {
      this.initEditUserStatus();
    }
  }

  /**
   * 初始化修改用户的状态信息
   */
  initEditUserStatus() {
    this.editUserObjRules = {
      password: [],
      username: [],
      mobile: [],
    };
    // 恢复用户信息的初始状态
    this.userInfo = { ...this.sourceUserInfo };
    // 初始化
    this.editUserMode = 'editUser';
  }

  /**
   * 修改用户账号的改变事件
   */
  editUsernameChange() {
    // 1.通过账号查询该账号是否已经存在
    // 1.2.如果存在，修改userId；
    // 1.3.如果不存在，进入注册模式（密码必填）；
    userManagementServe
      .getInfoByAccount(this.userInfo.username)
      .then((res: any) => {
        if (res.code === '200') {
          const userInfoByAccount = res.data;
          if (userInfoByAccount === null) {
            // 注册
            this.editUserModeAdd();
          } else {
            // 更换账号归属
            this.userInfo = res.data;
            this.editUserModeEdit();
          }
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((res: any) => {
        // this.$message.error('添加失败,请稍后重试!');
        this.$message.error(res.msg);
      });
  }

  /**
   * 修改用户模式=注册
   */
  editUserModeAdd() {
    this.$confirm('该账号不存在是否进行注册该账号?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.editUserMode = 'addUser';
        // 注册模式下，密码必填
        const editUserObjRules: any = this.editUserObjRules;
        editUserObjRules.password = [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { max: 20, message: '长度最大为20个字符', trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' },
        ]; // 用户密码验证规则
        this.editUserObjRules = editUserObjRules;
      })
      .catch(() => {
        this.initEditUserStatus();
      });
  }

  /**
   * 修改用户模式=修改
   */
  editUserModeEdit() {
    this.editUserMode = 'editUser';
    // 初始化验证信息
    const editUserObjRules: any = this.editUserObjRules;
    editUserObjRules.password = [
      { max: 20, message: '长度最大为20个字符', trigger: 'blur' },
      { validator: this.validatePassword, trigger: 'blur' },
    ];
    this.editUserObjRules = editUserObjRules;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，清空内容并返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.$emit('update:flag', 1);
  }
}
